import { render, staticRenderFns } from "./ImsOfferingStatusWidet.vue?vue&type=template&id=0d8c6954&"
import script from "./ImsOfferingStatusWidet.vue?vue&type=script&lang=js&"
export * from "./ImsOfferingStatusWidet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports